import { Component, Input } from '@angular/core';
import { Customer } from './../../../../../_shared/model/customer.model';

@Component({
    selector: 'main-calendar-popup-header',
    templateUrl: './main-calendar-popup-header.component.html',
    styles: [],
})
export class MainCalendarPopupHeaderComponent {
    @Input()
    selectedCustomerForNewTerm: Customer;
}
